import {
  deleteDataAPI,
  getDataAPI,
  postDataAPI,
} from "../../../services/apiWrapper";
import { errorAlert, successAlert } from "../../../utils/alert";

/*
 * FAQs and testimonials.
 *
 * Both are the same shape of thing - a list the council writes, split by who
 * it is for - so they share one file and one set of helpers. The website asks
 * for one audience at a time and never sees the hidden rows; the council asks
 * without `active` and sees everything.
 */

const adminToken = () => localStorage.getItem("adminToken");

const query = (params) => {
  const q = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== "") {
      q.append(key, value);
    }
  });
  return q.toString() ? `?${q.toString()}` : "";
};

/* ------------------------------- FAQs ------------------------------- */

/**
 * @param {object} params  audience, trade, and active:1 for the website
 * @returns {{list: object[], counts: object}}
 */
export const getFaqs = (params = {}) => async (dispatch) => {
  try {
    const url = params.active
      ? `faqs${query(params)}`
      : `admin/faq/list${query(params)}`;

    const response = await dispatch(
      getDataAPI(url, params.active ? undefined : adminToken())
    );
    return {
      list: response.data.data || [],
      counts: response.data.counts || {},
    };
  } catch (error) {
    return { list: [], counts: {} };
  }
};

export const saveFaq = (data, id) => async (dispatch) => {
  try {
    const url = id ? `admin/faq/update/${id}` : "admin/faq/create";
    const response = await dispatch(postDataAPI(url, data, adminToken()));
    successAlert(response.data.message);
    return true;
  } catch (error) {
    errorAlert(error.response?.data?.message || "That could not be saved.");
    return false;
  }
};

export const deleteFaq = (id) => async (dispatch) => {
  try {
    const response = await dispatch(
      deleteDataAPI(`admin/faq/delete/${id}`, adminToken())
    );
    successAlert(response.data.message);
    return true;
  } catch (error) {
    errorAlert(error.response?.data?.message || "That could not be deleted.");
    return false;
  }
};

/* --------------------------- testimonials --------------------------- */

export const getTestimonials = (params = {}) => async (dispatch) => {
  try {
    const url = params.active
      ? `testimonials${query(params)}`
      : `admin/testimonial/list${query(params)}`;

    const response = await dispatch(
      getDataAPI(url, params.active ? undefined : adminToken())
    );
    return {
      list: response.data.data || [],
      counts: response.data.counts || {},
    };
  } catch (error) {
    return { list: [], counts: {} };
  }
};

export const saveTestimonial = (data, id) => async (dispatch) => {
  try {
    const url = id
      ? `admin/testimonial/update/${id}`
      : "admin/testimonial/create";
    const response = await dispatch(postDataAPI(url, data, adminToken()));
    successAlert(response.data.message);
    return true;
  } catch (error) {
    errorAlert(error.response?.data?.message || "That could not be saved.");
    return false;
  }
};

export const deleteTestimonial = (id) => async (dispatch) => {
  try {
    const response = await dispatch(
      deleteDataAPI(`admin/testimonial/delete/${id}`, adminToken())
    );
    successAlert(response.data.message);
    return true;
  } catch (error) {
    errorAlert(error.response?.data?.message || "That could not be deleted.");
    return false;
  }
};

/* The sections both lists are split by, named once so the admin screens and
   the website pages cannot drift apart. */
export const AUDIENCES = [
  { key: "student", label: "Student" },
  { key: "center", label: "Center" },
  { key: "college", label: "College / Institute" },
  { key: "general", label: "General" },
];

export const audienceLabel = (key) =>
  (AUDIENCES.find((a) => a.key === key) || {}).label || "General";
